import { render, staticRenderFns } from "./TourButton.vue?vue&type=template&id=2637722b&"
import script from "./TourButton.vue?vue&type=script&lang=ts&"
export * from "./TourButton.vue?vue&type=script&lang=ts&"
import style0 from "./styles/index.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports